(() => {
  TrackApp.myPagesOrderHistory = (() => {
    const trackReturnOrder = (eventLabel = '') => {
      TrackApp.trackInteraction('my account', 'my orders', `return order ${eventLabel}`);
    };

    return {
      trackReturnOrder,
    };
  })();
})();
